export { default } from "./ReviewsCount.jsx";
